<template>
  <div class="jump-to-top position-fixed" v-show="scrolledPastThreshold">
    <button
      type="button"
      class="jump-to-top-btn"
      @click="scrollToTop"
      aria-label="גלול לראש העמוד"
    >
      <img src="@/assets/icons/jump-to-top.svg" alt="" aria-hidden="true" />
    </button>
  </div>
</template>
<script>
const SCROLL_THRESHOLD = 120;

export default {
  data() {
    return {
      scrolledPastThreshold: false,
    };
  },
  mounted() {
    this.handleScroll();
    window.addEventListener('scroll', this.handleScroll, { passive: true });
  },
  unmounted() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      const scrollY =
        window.scrollY ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0;
      this.scrolledPastThreshold = scrollY > SCROLL_THRESHOLD;
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
  },
};
</script>
<style scoped>
.jump-to-top {
  display: block;
  z-index: 500;
  right: 15px;
  bottom: 75px;
  width: 50px;
  height: 50px;
  transition: bottom 0.2s;
}

.jump-to-top:hover {
  bottom: 77px;
}

.jump-to-top-btn {
  display: block;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  border: none;
  padding: 0;
  cursor: pointer;
  line-height: 0;
  background: transparent;
  border-radius: 50%;
}

.jump-to-top-btn img {
  display: block;
  width: 100%;
  height: 100%;
  background: transparent;
  filter: drop-shadow(1px 1px 4px rgba(60, 60, 60, 0.4));
  transition: filter 0.2s;
}

.jump-to-top:hover .jump-to-top-btn img {
  filter: drop-shadow(1px 2px 8px rgba(60, 60, 60, 0.4));
}
</style>
